module.exports = __webpack_public_path__ + "img/footer-img-dbls.20325e2.jpg";